"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEntityGroup = void 0;
/**
 * @public
 * {@inheritDoc IEntityGroup}
 */
class AEntityGroup {
    isEntityInGroup(entity) {
        return this.entitiesInGroup.has(entity);
    }
}
exports.AEntityGroup = AEntityGroup;
//# sourceMappingURL=a-entity-group.js.map